interface UserIdentity {
  name: string;
  email: string;
}

export function getUserInitials({ name, email }: UserIdentity): string {
  const trimmed = name.trim();

  if (trimmed) {
    const parts = trimmed.split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  const localPart = email.split('@')[0] ?? '';
  const segments = localPart.split('.');
  if (segments.length >= 2) {
    return (segments[0][0] + segments[segments.length - 1][0]).toUpperCase();
  }
  return localPart[0]?.toUpperCase() ?? '';
}
